import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import Link from "next/link";

type Props = {
	backToEditPath: string;
	message: string;
	variant: "error" | "info";
};

export function UnavailableState({ backToEditPath, message, variant }: Props) {
	return (
		<Grid
			gap={designTokens["spacing/l"]}
			justifyItems="center"
			mt={designTokens["spacing/6xl"]}
		>
			<Alertv2 variant={variant}>
				<Paragraph>{message}</Paragraph>
			</Alertv2>
			<TextLink as={Link} color="link" href={backToEditPath}>
				見積作成画面へ戻る
			</TextLink>
		</Grid>
	);
}
